// removed by extract-text-webpack-plugin
module.exports = {"root":"marketingBlock-module_root_1sVqP","title":"marketingBlock-module_title_3wdum","imgWrapper":"marketingBlock-module_imgWrapper_3degi","description":"marketingBlock-module_description_1X2lD"};


//////////////////
// WEBPACK FOOTER
// ./client/pages/home/marketingBlock/marketingBlock.module.css
// module id = 477
// module chunks = 1 3